// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"Buttons_buttonsContainer__2rFFT","icons":"Buttons_icons__4nO9O"};